import axios from "axios";

export async function fetchProfile() {
  let response = await axios.get(
    `${process.env.REACT_APP_API_URL}/private/profile/`
  );
  return response.data;
}
